import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css';
import UHTLanding from './pages/UHTLanding';
import Dashboard from './componenents/Dashboard';

function App() {
  return (
    <>
    <Routes>
      <Route path="/">
        <Route exact path="/" element={<Navigate to="/homepage" />} />
        <Route path="/homepage" element={<UHTLanding />} />
        <Route path="/txn-dashboard" element={<Dashboard />} />
      </Route>
     </Routes>
    </>
  );
}
export default App;
